// extracted by mini-css-extract-plugin
export default {"active":"Sidebar_active__R-FGa","inactive":"Sidebar_inactive__TEQVv","navIcon":"Sidebar_navIcon__jXXKx","navBtn":"Sidebar_navBtn__+g54a"};